import { Modal } from '@mui/material'
import Box from '@mui/material/Box'
import { useEffect, useState } from 'react'

type ModalWithScrollProps = {
	children: React.ReactNode
	show: boolean
	onClose?: () => void
}

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: {
		xs: '95%',
		sm: '80%',
		md: '800px',
	},
	maxWidth: '800px',
	maxHeight: {
		xs: '95%',
		sm: '85%',
	},
	backgroundColor: 'background.paper',
	overflow: 'auto',
	p: { xs: 2, sm: 3, md: 4 },
	boxShadow: 24,
	borderRadius: 2,
	outline: 'none',
}

export default function ModalWithScroll({ children, show, onClose }: ModalWithScrollProps) {
	const [open, setOpen] = useState(show)

	useEffect(() => setOpen(show), [show])

	return (
		<Modal open={open} onClose={onClose}>
			<Box sx={style}>{children}</Box>
		</Modal>
	)
}
